var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 17.5,
    viewBox: "0 0 14.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_details",
    "data-name": "View details",
    transform: "translate(-426.938 -716.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reader-outline_2_",
    "data-name": "reader-outline (2)",
    transform: "translate(427.688 716.86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 13,
    height: 16,
    rx: 2,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M176,128h6.17M176,131.085h6.17M176,134.17h3.085",
    transform: "translate(-172.425 -124.453)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetails);
export default __webpack_public_path__ + "static/media/View-details.b98e435679d062aabc5e0b2a430a6595.svg";
export { ForwardRef as ReactComponent };